export default __webpack_public_path__ + "static/iphone-03-334b049e45971e1784102d9ced3e4d61.png";